/*
 *
 * RegAttemptsExceededModal
 *
 * @version 1.0.0
 * @author NEOSYN\user
 * @since 08-Oct-2024
 */

import React from 'react'
import PropTypes from 'prop-types'
import './RegAttemptsExceededModal.scss'
import formattedMessage from './languageModule'
import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'
import { nullSafe } from 'Utility/globalMethods'
import componentConfig from 'Route/Registration/modules/componentConfig'
import appEnvRemap from 'Utility/appEnvRemap'

const RegAttemptsExceededModal = (props) => {
  const radioboxSecurityCode = nullSafe(
    () => componentConfig.regAttemptsExceededModal.descriptionChanged.isVisible(),
    false
  )

  const redirectToLogin = () => {
    props.actions.doHidePopup()
    window.location.replace(appEnvRemap.REDIRECT_PATH_LOGIN)
  }

  return (
    <Toggle>
      <MerchantModal
        title={formattedMessage.title}
        description={radioboxSecurityCode ? formattedMessage.descriptionNexi : formattedMessage.description}
        primaryButtonLabel={formattedMessage.primaryButtonLabel}
        primaryAction={redirectToLogin}
      />
    </Toggle>
  )
}

RegAttemptsExceededModal.propTypes = {
  actions: PropTypes.object.isRequired
}

RegAttemptsExceededModal.defaultProps = {
  actions: {}
}

export default RegAttemptsExceededModal
